import { render, staticRenderFns } from "./NotifiedUser.page.vue?vue&type=template&id=98350358&scoped=true"
import script from "./NotifiedUser.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifiedUser.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotifiedUser.page.vue?vue&type=style&index=0&id=98350358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98350358",
  null
  
)

export default component.exports